import React, { FunctionComponent, useRef,useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import ReactToPrint from "react-to-print";
import { Typography, DialogContentText,IconButton } from "@material-ui/core";
import { useStore } from "../../../store/index";
import storeLogo from "../../../assets/images/voucherLogo.bmp";
import moment from "moment";
import { useItemReturnStyles } from "../useItemReturnStyles";
import CloseIcon from '@mui/icons-material/Close';

type BarcodeDialogProps = {
  openBarcodeDialog: boolean;
  barcodeValue: string;
  type: string;
  printDetails: Array<Object>;
  rePrint: boolean;
  totalPrice: number;
  itemReturnDays: string;
  isCreditCustomer: boolean;
  handleCloseBarcodeDialog: () => void;
  clearDataAfterPrint: () => void;
  barcodeCancelConfirmationDialog: boolean;
  handleCloseBarcodeDialogAgree: () => void;
  handleCloseBarcodeDialogDisAgree: () => void;
  handleClose:()=>void;
};
let Barcode = require("react-barcode");

export const BarcodeDialog: FunctionComponent<BarcodeDialogProps> = ({
  openBarcodeDialog,
  type,
  barcodeValue,
  printDetails,
  rePrint,
  handleCloseBarcodeDialog,
  totalPrice,
  itemReturnDays,
  clearDataAfterPrint,
  barcodeCancelConfirmationDialog,
  handleCloseBarcodeDialogAgree,
  handleCloseBarcodeDialogDisAgree,
  isCreditCustomer,
  handleClose
}) => {
  const componentRef = useRef<any>();
  const [user] = useStore("auth", "user");
  const styles = useItemReturnStyles();
  const return_type = type === "exchange" ? "Exchange" : "Return";
  
  //console.log("printDetails",printDetails);
  return (
    <div>
      {type === "return" ? (
        <Dialog
          open={openBarcodeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          {!isCreditCustomer && (
            <DialogTitle id="alert-dialog-title" style={{display:"flex",flexDirection:"row"}}>
              {"Do you want to print the following barcode?"}
              <IconButton
              aria-label="close"
              style={{marginLeft:"8em"}}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
            </DialogTitle>
            
          )}
          <DialogContent>
            {isCreditCustomer ? (
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={2}
              >
                <Grid item lg={12}>
                  <Typography gutterBottom className={styles.amountTitle}>
                    Item return created successfully
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={2}
              >
                <Grid item xs={12} ref={componentRef} style={{ height: "100%" }}>
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    spacing={2}
                  >
                    {" "}
                    <Grid
                      item
                      xs={12}
                      style={{ textAlign: "center", paddingTop: "2em" }}
                    >
                      <img
                        src={storeLogo}
                        alt="storeLogo"
                        style={{ height: "6em", width: "7em" }}
                      />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                      <Typography
                        gutterBottom
                        className={styles.dialogMainTitleArabic}
                      >
                        {user.companyName_AR}
                      </Typography>
                      <Typography
                        gutterBottom
                        className={styles.dialogSubTitleArabic}
                      >
                        {user.storeName_AR}
                      </Typography>
                      <Typography
                        gutterBottom
                        className={styles.dialogMainTitle}
                      >
                        {user.companyName_EN}
                      </Typography>
                      <Typography
                        gutterBottom
                        className={styles.dialogSubTitle}
                      >
                        {user.storeName_EN}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{ textAlign: "center", paddingTop: "2em" }}
                    >
                      <Typography
                        gutterBottom
                        className={styles.dialogSubTitle}
                      >
                        {return_type} Voucher
                      </Typography>
                      <Typography gutterBottom className={styles.amountTitle}>
                        Amount :{" "}
                        {rePrint
                          ? printDetails.map((i: any) => i.total_amount)
                          : totalPrice.toFixed(2)}{" "}
                        QR
                      </Typography>
                    </Grid>
                    {!isCreditCustomer && (
                      <>
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                          {barcodeValue ? (
                            <Barcode value={barcodeValue.toString()} />
                          ) : (
                            <Barcode
                              value={printDetails.map((i: any) => i.barcode)}
                            />
                          )}
                        </Grid>
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            className={styles.dialogSubTitle}
                          >
                            Valid From :{" "}
                            {rePrint
                              ? printDetails.map((i: any) =>
                                  moment(i.created_at).format(
                                    "DD-MMM-YYYY  h:mm:ss a"
                                  )
                                )
                              : moment().format("DD-MMM-YYYY  h:mm:ss a")}
                            {/* {moment().format("DD-MMM-YYYY  h:mm:ss a")} */}
                          </Typography>
                          <Typography
                            gutterBottom
                            className={styles.dialogSubTitle}
                          >
                            Valid Upto :{" "}
                            {rePrint
                              ? printDetails.map((i: any) =>
                                  moment(i.created_at)
                                    .add(i.return_days, "days")
                                    .format("DD-MMM-YYYY  h:mm:ss a")
                                )
                              : moment()
                                  .add(itemReturnDays, "days")
                                  .format("DD-MMM-YYYY  h:mm:ss a")}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12}>
                      <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                      >
                        <Grid item xs={1}></Grid>
                        <Grid item xs={6}>
                          <Typography className={styles.normalTextAdmin}>
                            Served By:{user.full_name}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{ textAlign: "center", marginTop: "-1.5em" }}
                    >
                      <Typography gutterBottom>
                        ---------------------------------------------------
                      </Typography>
                      <Typography gutterBottom className={styles.normalText}>
                        {moment().format("DD-MMM-YYYY  h:mm:ss a")}
                      </Typography>
                      <Typography gutterBottom>
                        ---------------------------------------------------
                      </Typography>
                      <Typography gutterBottom className={styles.normalText}>
                        Voucher cannot redeemed for cash{" "}
                      </Typography>
                      <Typography gutterBottom className={styles.normalText}>
                        Terms & conditions apply{" "}
                      </Typography>
                      <Typography gutterBottom className={styles.normalText}>
                        {}
                      </Typography>
                      {rePrint ? <Typography>Duplicate Copy</Typography> : null}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            {isCreditCustomer ? (
              <>
                <Button onClick={clearDataAfterPrint}>Done</Button>
              </>
            ) : (
              <>
                <ReactToPrint
                  trigger={() => <Button>Print</Button>}
                  onAfterPrint={clearDataAfterPrint}
                  content={() => componentRef.current}
                />
                {/* <Button onClick={handleCloseBarcodeDialog}>Cancel</Button> */}
              </>
            )}
          </DialogActions>
        </Dialog>
      ) : (
        // Exchange scenario
        <Dialog
          open={openBarcodeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
         <DialogTitle id="alert-dialog-title" style={{display:"flex",flexDirection:"row"}}>
               {"Do you want to print the following exchange voucher?"}
              <IconButton
              aria-label="close"
              style={{marginLeft:"4em"}}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
            </DialogTitle>
          <DialogContent>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={12} ref={componentRef} style={{ height: "100%" }}>
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid
                    item
                    xs={12}
                    style={{ textAlign: "center", paddingTop: "2em" }}
                  >
                    <img
                      src={storeLogo}
                      alt="storeLogo"
                      style={{ height: "6em", width: "7em" }}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "center" }}>
                    <Typography
                      gutterBottom
                      className={styles.dialogMainTitleArabic}
                    >
                      {user.companyName_AR}
                    </Typography>
                    <Typography
                      gutterBottom
                      className={styles.dialogSubTitleArabic}
                    >
                      {user.storeName_AR}
                    </Typography>
                    <Typography gutterBottom className={styles.dialogMainTitle}>
                      {user.companyName_EN}
                    </Typography>
                    <Typography gutterBottom className={styles.dialogSubTitle}>
                      {user.storeName_EN}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ textAlign: "center", paddingTop: "2em" }}
                  >
                    <Typography gutterBottom className={styles.dialogMainTitle}>
                      {return_type} Voucher
                    </Typography>
                    {/* <Typography gutterBottom className={styles.amountTitle}>
                    Amount :{" "}
                      {rePrint
                        ? printDetails.map((i: any) => i.total_amount)
                        : totalPrice.toFixed(3)}{" "}
                      QR
                    </Typography> */}
                    <Typography gutterBottom className={styles.dialogSubTitle}>
                      {printDetails.map((i: any, index: number) => (
                        <div key={index} style={{ marginBottom: "8px" }}>
                          <p>{i.ref_plu}</p>
                          <p>{i.item_name}</p>
                        </div>
                      ))}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="center"
                    >
                      <Grid item xs={1}></Grid>
                      <Grid item xs={6}>
                        <Typography className={styles.normalTextAdmin}>
                          Served By:{user.full_name}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ textAlign: "center", marginTop: "-1.5em" }}
                  >
                    <Typography gutterBottom>
                      ---------------------------------------------------
                    </Typography>
                    <Typography gutterBottom className={styles.normalText}>
                      {moment().format("DD-MMM-YYYY  h:mm:ss a")}
                    </Typography>
                    <Typography gutterBottom>
                      ---------------------------------------------------
                    </Typography>
                    <Typography gutterBottom className={styles.normalText}>
                      Voucher cannot redeemed for cash
                    </Typography>
                    <Typography gutterBottom className={styles.normalText}>
                      Terms & conditions apply
                    </Typography>
                    <Typography gutterBottom className={styles.normalText}>
                      {}
                    </Typography>
                    {rePrint ? <Typography>Duplicate Copy</Typography> : null}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <ReactToPrint
              trigger={() => <Button>Print</Button>}
              onAfterPrint={clearDataAfterPrint}
              content={() => componentRef.current}
            />
          </DialogActions>
        </Dialog>
      )}
      {barcodeCancelConfirmationDialog ? (
        <Dialog
          open={barcodeCancelConfirmationDialog}
          onClose={handleCloseBarcodeDialogDisAgree}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to cancel this process?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseBarcodeDialogAgree}>Yes</Button>
            <Button onClick={handleCloseBarcodeDialogDisAgree}>No</Button>
          </DialogActions>
        </Dialog>
      ) : (
        ""
      )}
    </div>
  );
};
